<script lang="ts">
	interface Props {
		strokeColor?: string;
	}

	let { strokeColor = "black" }: Props = $props();
</script>

<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_607_47)">
		<path
			d="M8 2H56C59.3137 2 62 4.68629 62 8V17C62 17.5523 61.5523 18 61 18C58.2386 18 56 20.2386 56 23V32V41C56 43.7614 58.2386 46 61 46C61.5523 46 62 46.4477 62 47V56C62 59.3137 59.3137 62 56 62H8C4.68629 62 2 59.3137 2 56V47C2 46.4477 2.44771 46 3 46C5.76142 46 8 43.7614 8 41V32V23C8 20.2386 5.76142 18 3 18C2.44772 18 2 17.5523 2 17V8C2 4.68629 4.68629 2 8 2Z"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
		/>
		<rect
			x="20"
			y="21"
			width="24"
			height="21"
			rx="6"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
		/>
		<circle cx="14" cy="11" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
		<circle cx="26" cy="11" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
		<circle cx="38" cy="11" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
		<circle cx="50" cy="11" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
		<circle cx="14" cy="52" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
		<circle cx="26" cy="52" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
		<circle cx="38" cy="52" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
		<circle cx="50" cy="52" r="3.5" stroke={strokeColor} class="svg-stroke" stroke-width="3" />
	</g>
	<defs>
		<clipPath id="clip0_607_47">
			<rect width="64" height="64" fill="white" />
		</clipPath>
	</defs>
</svg>

<style>
</style>
